import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'

const dialogContentClass =
  'max-w-[640px] gap-0 rounded-2xl border-[#e7e9ef] p-8 shadow-[0_8px_16px_-4px_rgba(38,45,66,0.1),0_1px_4px_-4px_rgba(38,45,66,0.05)] sm:rounded-2xl [&>button]:hidden'
const cancelBtnClass =
  'h-11 rounded-xl border border-[#e7e9ef] bg-white p-3 text-sm font-medium leading-none text-[#171a20] hover:bg-[#fbfbfc]'
const confirmBtnClass =
  'h-11 rounded-xl border border-[#ff5a1f] bg-[#ff5a1f] p-3 text-sm font-medium leading-none text-white hover:bg-[#e6511c]'

export function InvoiceValidateDialog({
  open,
  busy,
  invoiceNumber,
  onOpenChange,
  onConfirm,
}: {
  open: boolean
  busy: boolean
  invoiceNumber: string
  onOpenChange: (open: boolean) => void
  onConfirm: () => void | Promise<void>
}) {
  const { t } = useTranslation('invoices')

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={dialogContentClass}
        overlayClassName='bg-black/70 backdrop-blur-[2px]'
      >
        <div className='flex flex-col gap-6'>
          <div className='flex flex-col gap-6'>
            <div className='flex flex-col gap-3 text-[#171a20]'>
              <DialogTitle className='font-heading text-base font-semibold leading-[1.2] tracking-normal text-[#171a20]'>
                {t('detail.validateDialog.title', { number: invoiceNumber })}
              </DialogTitle>
              <p className='max-w-[552px] font-sans text-sm font-normal leading-[1.4] text-[#171a20]'>
                {t('detail.validateDialog.descriptionPrefix')}{' '}
                <span className='font-medium'>
                  {t('detail.validateDialog.issued')}
                </span>{' '}
                {t('detail.validateDialog.descriptionSuffix')}
              </p>
            </div>

            <div className='flex flex-col gap-1.5 rounded-xl border border-[#2550cc] bg-[#ebf1fe] p-3 font-sans text-sm leading-[1.4]'>
              <p className='font-medium text-[#2550cc]'>
                {t('detail.validateDialog.warningTitle')}
              </p>
              <p className='text-[#171a20]'>
                {t('detail.validateDialog.warningText')}
              </p>
            </div>
          </div>

          <div className='flex flex-col-reverse gap-3 sm:flex-row sm:items-center sm:justify-end sm:gap-4'>
            <Button
              type='button'
              variant='outline'
              className={cancelBtnClass}
              disabled={busy}
              onClick={() => onOpenChange(false)}
            >
              {t('detail.validateDialog.cancel')}
            </Button>
            <Button
              type='button'
              className={confirmBtnClass}
              disabled={busy}
              onClick={onConfirm}
            >
              {t('detail.validateTheInvoice')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
